import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationGTS from "../../../../src/content/giving-tuesday-spanish/customConfirmation";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationGTS,
  React
};